import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// --- 🌗 Favicon dinámico (modo claro/oscuro) ---
function setDynamicFavicon() {
  let favicon = document.querySelector('link[rel="icon"]');

  // Si no existe aún, lo creamos
  if (!favicon) {
    favicon = document.createElement('link');
    favicon.rel = 'icon';
    favicon.type = 'image/svg+xml';
    document.head.appendChild(favicon);
  }

  // Detecta si el sistema está en modo oscuro
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

  // Aplica el ícono correspondiente
  favicon.href = prefersDark ? '/Logo-d.svg' : '/Logo-l.svg';
}

// Ejecuta una vez al cargar
setDynamicFavicon();

// Escucha los cambios del sistema (modo oscuro/claro)
const darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)');
darkModeQuery.addEventListener('change', () => setDynamicFavicon());

// --- Fin del favicon dinámico ---

// Renderizado principal
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Métricas opcionales
reportWebVitals();
